<div *ngIf="visible" class="rollup-tabs-content-card-header-container">
  <div class="rollup-tabs-content-card-header py-6 px-11 align-baseline">
    <div class="mb-3">
      <app-checked-and-held-items-banner-container
        [recordIds]="materialTab.recordIds"
        [instanceIds]="instanceIds"
        [hasEcontentIssues]="hasEcontentIssues"
        [vendors]="materialTab?.availability?.vendors"
        [isElectronic]="isElectronic">
      </app-checked-and-held-items-banner-container>
    </div>
    <div class="row no-gutters">
      <div class="col">
        <div class="w-100">
          <app-electronic-item-availability
            *ngIf="isElectronic; else physicalItemTmpl"
            [materialTab]="materialTab"
            [nonIntegratedLogo]="nonIntegratedLogo"
            [availabilityUpdateInfo]="availabilityUpdateInfo"
            [vendorsLogo]="vendorsLogo">
          </app-electronic-item-availability>

          <ng-template #physicalItemTmpl>
            <app-physical-item-availability [materialTab]="materialTab"
                                            [availabilityStatus]="availabilityUpdateInfo?.status?.general">
            </app-physical-item-availability>
          </ng-template>
        </div>

        <div *ngIf="this.materialTab.holdingsLatestReceived" class="w-100 mb-3">
          <div class="row">
            <div class="col-auto rollup-tabs-content-card-col-mw-fixed">
              {{'latestReceived' | translate}}
            </div>
            <div class="w-100 d-md-none"></div>
            <div class="col" data-automation-id="latest-received">
              <p class="mb-1">{{this.materialTab.holdingsLatestReceived}}</p>
            </div>
          </div>
        </div>

        <div class="w-100 mb-3"
             *ngIf="materialTab.holdingsDisplayStrings?.length > 0 || materialTab.supplementsDisplayStrings?.length > 0
             || materialTab.indexesDisplayStrings?.length > 0">
        <app-library-has [issuesStrings]="materialTab.holdingsDisplayStrings"
                           [supplementsStrings]="materialTab.supplementsDisplayStrings"
                           [indexesStrings]="materialTab.indexesDisplayStrings"
                           [isFullScreen]="true">
          </app-library-has>
        </div>

        <div class="w-100 mb-3" *ngIf="materialTab?.multimediaLinks?.length">
          <div class="row">
            <div class="col-auto rollup-tabs-content-card-col-mw-fixed">
              {{'multimedia' | translate}}
            </div>
            <div class="w-100 d-md-none"></div>
            <div class="col" data-automation-id="multimedia-links">
              <div *ngFor="let link of materialTab.multimediaLinks">
                <a class="multimedia-link" target="_blank"
                   href="{{ link.url }}">{{ link?.label ? link.label : link.url }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <app-nlb-item-locator
          *ngIf="isNlbCustomer && !isElectronic && materialTab.callNumber && firstAvailableBarcode"
          [fgId]="fgId"
          [tabName]="materialTab.translationKey | translate"
          [recordId]="firstAvailableBarcode"
          [title]="fgTitle"
          [callNumber]="materialTab.callNumber"
          [collectionLocationName]="materialTab.itemCollectionLocation"
          [locationLabel]="locations?.[0]?.label"
          [codes]="locations?.[0]?.codes"
          [mode]=1
          [language]="firstAvailableLanguage ?? language"
        ></app-nlb-item-locator>

        <div class="w-100 mb-3" *ngIf="!isElectronic && (locations?.length || materialTab.hasMoreLocations)">
          <div class="row">
            <div class="col">
              <ins-rollup-tabs-content-locations [locations]="locations"
                                                 [displayAllLocationsLink]="materialTab.hasMoreLocations"
                                                 (locationClicked$)="onCheckItemAvailability($event)"
                                                 (allLocationsClicked$)="onCheckItemAvailability()">
              </ins-rollup-tabs-content-locations>
            </div>
          </div>
        </div>

      </div>

      <div class="col-sm-auto d-flex align-items-end justify-content-end action-elements-wrap">
        <div *ngIf="showQrCode()" class="qr-code-container">
          <app-nlb-qr-code
            [recordId]="firstAvailableRecordId"
            [reserveId]="availabilityUpdateInfo?.reserve?.id"
            [isElectronic]="isElectronic"
            [size]="'4'"
          ></app-nlb-qr-code>
        </div>
        <div class="d-flex flex-column">
          <app-toolbar-buttons
            #getItButton
            *ngIf="!materialTab?.availability?.isGetItSuppressed"
            [hasEcontentIssues]="hasEcontentIssues"
            [label]="materialTab.translationKey ? (materialTab.translationKey | translate) : materialTab.name"
            [tabName]="materialTab.name"
            [recordId]="materialTab.recordIds"
            [isElectronicResource]="isElectronic"
            [availability]="availabilityUpdateInfo?.status"
            [reserve]="availabilityUpdateInfo?.reserve"
            [eVendorAvailabilityPending]="availabilityUpdateInfo?.eVendorAvailabilityPending"
            [eResourceUrls]="materialTab?.availability.urls"
            [resourceId]="fgId"
            [title]="fgTitle"
            (getIt$)="getIt$.emit($event)"
            (placeHold$)="placeHold$.emit($event)"
            (checkLocationAndEditionInfo$)="onCheckEditions()">
          </app-toolbar-buttons>
          <ng-container *ngIf="isNlbCustomer && !isElectronic">
            <app-nlb-borrow-n-deliver class="mt-2" [recordIds]="materialTab.recordIds"></app-nlb-borrow-n-deliver>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="row justify-content-end no-gutters mt-2" *ngIf="shouldShowAvailabilityInfo()">
      <div class="col text-right">
        <app-holds-and-copies-message [shouldHideHolds]="featureHideNumberOfHolds" [holds]="getHoldsCount()" [copies]="getCopiesCount()"></app-holds-and-copies-message>
      </div>
    </div>
  </div>

  <div class="location-edition-table-container d-flex flex-column">
    <div class="d-flex flex-row">
      <button (click)="toggleLocationAndEditionInfo()"
        class="toggle-table-btn text-wrap px-5"
        data-automation-id="toggle-edition-information-button"
        [attr.aria-expanded]="tableExpanded"
        [attr.aria-label]="'editionInformationForTitle' | translate : {title: fgTitle}"
      >
        <span *ngIf="!isElectronic; else electronicInfo"
          translate
          data-automation-id="loc-and-edtn-info" class="mr-2">locationAndEditionInfoBtn</span>
        <ng-template #electronicInfo>
          <span translate data-automation-id="check-edtn-info" class="mr-2">editionInfoBtn</span>
        </ng-template>
          <fa-icon class="arrow-icon" [icon]="tableExpanded ? arrowIconUp : arrowIconDown"></fa-icon>
      </button>
      <div class="editions-search-container d-flex flex-row align-items-center justify-content-end w-100 px-5"
           data-automation-id="editions-search-bar"
           (click)="$event.stopPropagation();">
        <div class="d-flex flex-row align-items-center">
          <fa-icon [icon]="searchIcon" class="position-absolute mx-1"></fa-icon>
          <input class="w-100 px-5 py-1 m-0"
                 #editionsSearchInput
                 [attr.aria-label]="'searchEditionsLabel' | translate"
                 (keyup)="onEditionsSearch($event.target.value)"
                 (click)="$event.stopPropagation();">
        </div>
      </div>
    </div>
    <app-overdrive-and-sierra-edition-availability-container
      *ngIf="tableExpanded"
      [type]="materialTab.type"
      [containerData]="materialTab.editions"
      [resourceId]="fgId">
      <ng-template let-availabilityUpdates="availabilityUpdates" let-hasEditionEcontentIssues="hasEditionEcontentIssues">
        <app-location-and-edition-table-container
          [availabilityUpdates]="availabilityUpdates"
          [isElectronic]="isElectronic"
          [label]="materialTab.translationKey ? (materialTab.translationKey | translate) : materialTab.name"
          [tabName]="materialTab.name"
          [nonIntegratedLogo]="nonIntegratedLogo"
          [hasEditionEcontentIssues]="hasEditionEcontentIssues"
          [fgId]="fgId"
          (getIt$)="getIt$.emit($event)"
          (placeHold$)="placeHold$.emit($event)"
          (tableInited)="onTableInited()">
        </app-location-and-edition-table-container>
      </ng-template>
    </app-overdrive-and-sierra-edition-availability-container>
  </div>
</div>
